import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Logo from './components/Logo';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

const MainContent = styled.main`
  z-index: 2;
  flex: 1;
  display: flex;
  align-items: ${props => props.$isHome ? 'center' : 'flex-start'};
  justify-content: center;
  width: 100%;
  padding: ${props => props.$isHome ? '0' : '40px 20px'};
  box-sizing: border-box;
  overflow-y: auto;
  margin-top: ${props => props.$isHome ? '-80px' : '0'};
  
  @media (max-width: 480px) {
    padding: ${props => props.$isHome ? '0' : '20px 15px'};
    margin-top: 0;
  }
`;

function App() {
  return (
    <BrowserRouter>
      <AppContainer>
        <Routes>
          <Route path="/" element={
            <MainContent $isHome>
              <Logo />
            </MainContent>
          } />
          <Route path="/terms" element={
            <MainContent>
              <Terms />
            </MainContent>
          } />
          <Route path="/privacy" element={
            <MainContent>
              <Privacy />
            </MainContent>
          } />
        </Routes>
        <Footer />
      </AppContainer>
    </BrowserRouter>
  );
}

export default App;
